<template>
  <Form @submit="onSubmit">
    <div class="flex border-b border-dark-b">
      <h2 class="text-xl md:text-2xl font-semibold mr-6">Change Password</h2>
    </div>
    <div class="flex flex-wrap w-full pt-7 md:pt-12">
      <div class="lg:pr-5 w-full font-semibold text-lg lg:text-xl lg:w-1/2">
        <div class="pb-1">Current Password</div>
        <Field
          name="current_password"
          class="form-input text-lg md:text-xl"
          placeholder="Enter Current Password here..."
          type="password"
          :rules="isRequired"
          v-model="formData.current_password"
        />
        <div class="h-5">
          <ErrorMessage name="current_password" class="form-error"/>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap w-full">
      <div class="lg:pr-5 w-full font-semibold text-lg lg:text-xl lg:w-1/2">
        <div class="pb-1">New Password</div>
        <Field
          name="password"
          class="form-input text-lg md:text-xl"
          placeholder="Type new Password here..."
          type="password"
          :rules="isRequired"
          v-model="formData.password"
        />
        <div class="h-5">
          <ErrorMessage name="password" class="form-error"/>
        </div>
      </div>
      <div class="lg:pl-5 font-semibold text-lg lg:text-xl w-full lg:w-1/2">
        <div class="pb-1">Repeat New Password</div>
        <Field
          name="confirmPassword"
          class="form-input text-lg md:text-xl"
          placeholder="Confirm Password here..."
          type="password"
          :rules="isRequired"
          v-model="formData.password_confirmation"
        />
        <div class="md:h-12">
          <ErrorMessage name="confirmPassword" class="form-error"/>
        </div>
      </div>     
    </div>
    <div class="flex justify-end pt-6 pb-6">
      <button
        class="bg-blue text-white py-3 px-12 rounded-full font-bold"
      >
        Save
      </button>
    </div>
  </Form>
</template>
<script>
import { mapActions } from 'vuex'
import VeeValidate from '@/shared/mixins/VeeValidate'

export default {
  name: 'ChangePassword',
  mixins: [VeeValidate],
  data() {
    return {
      formData: {},
    }
  },
  methods: {
    ...mapActions([
      'changePassword'
    ]),
    async onSubmit() {
      const response = await this.changePassword(this.formatFormData())
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })
    },
    formatFormData() {
      const userData = new URLSearchParams()
      Object.keys(this.formData).forEach(key => {
        userData.append(key, this.formData[key] || '')
      })
      return userData
    }
  }
}
</script>
